import React, { Component } from "react";
import _ from 'lodash'
import { createStyles, Grid, withStyles, WithStyles } from "@material-ui/core";
import { MyPATDialog } from "../../../common";

const styles = () => createStyles({
  viewPreview :{
    width: "100%",
    minWidth: 450,
    textAlign: "center",
  },
});

interface Props extends WithStyles<typeof styles> {
  primaryConcepts: any[];
  secondaryConcepts: any[];
  conceptType: "primary" | "secondary" | "";
  onClose: () => void;
}

class ConceptIncludesPopup extends Component<Props> {
  renderConcepts = () => {
    const { conceptType, primaryConcepts, secondaryConcepts } = this.props;
    if (conceptType === "primary") {
      return primaryConcepts;
    }
    return secondaryConcepts;
  };
  render() {
    const { conceptType, onClose } = this.props;
    const {classes} = this.props;
    return (
      <MyPATDialog
        dialogOpen={true}
        dialogHasActions={true}
        dialogHeading={`${_.capitalize(conceptType)} Concepts`}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={onClose}
        isCustomBackground={false}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: false,
        }}
      >
        <Grid className={classes.viewPreview}>{this.renderConcepts()}</Grid>
      </MyPATDialog>
    );
  }
}

export default withStyles(styles)(ConceptIncludesPopup);
